<template>
    <div class="setDate-menu" v-show="showMenu">
        <scrollbar class="setDate-menu-wrap">
            <div class="setDate-menu-title">
                Год
                        <select class="setDate-menu-select" v-model="yearPeriod" @change="setMonth">
                            <option v-for="(item,index) in years" :key="index">{{item}}</option>
                        </select>
                <div class="setDate-menu-closeIcon">
                    <i class="mdi mdi-window-close" @click="closeMenu"></i>
                </div>
            </div>
            <div class="setDate-menu-week">
                <div class="setDate-menu-row">
                    <div class="setDate-menu-itemTitle">№ Недели</div>
                    <div class="setDate-menu-itemTitle">% Дохода</div>
                    <div class="setDate-menu-itemTitle">Отчет</div>
                </div>
                <div class="setDate-menu-row" v-for="(item,index) in weekInMonth.week" :key="index + 'week'">
                    <div class="setDate-menu-item" @click="setDate(item[item.length - 1].title)">{{item[item.length - 1].title}}</div>
                    <div :class="item[item.length - 1].profitRel < 0 ? 'color-red' : 'color-green'" class="setDate-menu-item" @click="setDate(item[item.length - 1].title)">{{(item[item.length - 1].profitRel).toFixed(2)}}%</div>
                    <div class="setDate-menu-item" @click="reportWidget(index, item)">
                        <i class="icon-blog"></i>
                    </div>
                </div>
            </div>
        </scrollbar>
        <scrollbar>
            <reportWidget v-if="showReportWidget !== null" :weekData="weekReportData" @close="closeReport"/>
        </scrollbar>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import reportWidget from './reportForWeek'
export default {
    components: {
       "scrollbar":VuePerfectScrollbar,
       reportWidget
    },
    data() {
        return {
            yearPeriod:null,
            years:null,
            monthPeriod:null,
            monthInYear:null,
            weekInMonth:null,
            lastWeeks:null,
            weekModel:null,
            showMenu:true,
            month: ['Январь', 'Февраль','Март','Апрель', 'Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
            showReportWidget:null,
            weekReportData:null,
        }
    },
    computed: {
        ...mapGetters({
              getYearStat: 'accountstat/getYearStat',
              getPeriod: 'accountstat/getPeriod',
              getMonthsInYear: 'accountstat/getMonthsInYear',
              getRestUri:'api/getApiUri'
        }),
    },
    methods: {
        setMonth() {
            //this.monthInYear = getMonthName(this.getMonthsInYear(this.symbol, this.yearPeriod));
            this.weekInMonth = this.getYearStat(this.symbol, this.yearPeriod);
        },
        setWeek() {
            let date = new Date (this.yearPeriod);
            //this.weekInMonth = getWeeksPeriods(this.getMonthStat(this.symbol, date), this);
            this.weekInMonth = this.getYearStat(this.symbol, date.getFullYear);
        },
        setDate(index) {
            //this.showMenu = false;
            //let arrWeek = this.weekModel.split('—');
            this.indexWeek = index;
            let week = null
            for (let i = 0; i < this.weekInMonth.week.length; i++) {
                for (let j = 0; j < this.weekInMonth.week[i].length; j++) {
                    if(this.weekInMonth.week[i][j].title && this.weekInMonth.week[i][j].title == this.indexWeek)
                   week = this.weekInMonth.week[i];
                }
            }         
            let dateFirstDay = new Date(week[week.length - 2].date);
            this.datePeriod = new Date(this.yearPeriod, dateFirstDay.getMonth(),dateFirstDay.getDate());
            let date = {period:this.datePeriod, week:this.indexWeek}
            this.$emit('setDate', date);
            //this.dateForTitle = this.datePeriod;
        },
        closeMenu() {
            this.$emit('closeMenu', false);
        },
        reportWidget(index,data) {
            this.weekReportData = data;
            this.showReportWidget = index;
        },
        closeReport() {
           this.showReportWidget = null; 
        }
    },
    created() {
        this.years = this.getPeriod(this.symbol);
        this.monthInYear = getMonthName(this.getMonthsInYear(this.symbol, this.years[this.years.length - 1]));
        this.yearPeriod = this.years[this.years.length - 1];
        this.monthPeriod = this.monthInYear[this.monthInYear.length - 1];
        //this.weekInMonth = getWeeksPeriods(this.getMonthStat(this.symbol), this)
        this.weekInMonth = this.getYearStat(this.symbol);
        this.lastWeeks  = this.weekInMonth.week.slice(this.weekInMonth.week.length - 4);
        this.weekModel = this.weekInMonth[this.weekInMonth.length - 1];
    }
}
function getMonthName(arrayMonth) {
        let month = ['Январь', 'Февраль','Март','Апрель', 'Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
        let monthName = [];
        for(let i = 0; i < arrayMonth.length; i++) {
            monthName.push(month[arrayMonth[i]]);
        }
        return monthName;
}
function getWeeksPeriods(monthStat,context) {
    let endsAndBeginWeeks = [];
    for(let i = 0; i < monthStat.week.length; i++) {
            endsAndBeginWeeks.push({
                begin:context.$datef(monthStat.week[i][0].date, 'd'),
                end:context.$datef(monthStat.week[i][monthStat.week[i].length - 2].date, 'd')
            })
    }
    return endsAndBeginWeeks;
}

</script>
<style lang="less" scoped>
.setDate-menu {
    position: absolute;
    top:40px;
    right: 40px;
    z-index: 4;
    display: flex;
    //max-height: 400px;
    height: 100%;
    overflow: auto;
    &-select {
        display: flex;
        justify-content: center;
        padding: 4px;
        font-size: 12px;
        font-family: 'Arimo';
        font-weight: 700;
        text-align: center;
        width: 60px;
        color: #fff;
        //line-height: 1.3;
        //padding: .6em 1.4em .5em .8em;s
        box-sizing: border-box;
        margin: 0;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        border: 1px #324258 solid;
        background-color: #324258;
        outline: none;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAHRJREFUSMftj7ENwkAQBEeGdlyOM/og9LsTR5RIYktDYIJH4j4wn3ET783eQpIkTdSxRyY6XNRdvTUyk7qpJcoMjY4ncAHWbyXqBDyAK+DZFXcPPpZUn6vOp+RRSVd5VVLewq2Sl5/FwZJ+nwdL+n6eJH/AC2fFjaeFV0LKAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA1LTE1VDEyOjA2OjM2KzAwOjAwCnWQQwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wNS0xNVQxMjowNjozNiswMDowMHsoKP8AAAAodEVYdHN2ZzpiYXNlLXVyaQBmaWxlOi8vL3RtcC9tYWdpY2stdjVmTzZzMVpzK/ieAAAAAElFTkSuQmCC');
        background-repeat: no-repeat, repeat;
        background-position: right .1em top 50%, 0 0;
        background-size: 1.65em auto, 100%;
        &:active {
            background-color:#324258;
            outline: none;
            padding: 4px;
            border: 1px #324258 solid;
        }
    }
    &-row {
        display: flex;
        border-top:1px solid #324258;
        height: 28px;
        border-bottom: 1px solid #293546;
        cursor: pointer;
        &:last-child {
            border-bottom:none;
        }
    }
    &-item {
        flex-basis: 50%;
        flex-grow: 1;
        text-align: center;
        font-family: 'Arimo';
        font-weight: 600;
        font-size: 13px;
        border-right: 1px solid #293546;
        &:last-child {
           border-right: none; 
        }
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &-itemTitle {
        font-family: 'Arimo';
        font-weight: 600;
        text-transform: uppercase;
        font-size: 11px;
        color:#9FB6D2;
        flex-basis: 50%;
        flex-grow: 1;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &-week {
        //margin-top: 4px;
    }
    &-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        padding:8px;
        box-sizing: border-box;
        background-color: #324258;
        border-bottom: 1px solid #293546;
        font-size: 12px;
        text-align: center;
        text-transform: uppercase;
        font-family: 'Arimo';
        color:#9FB6D2;
    }
    &-wrap {
        min-width:220px;
        background: #324258;
        height: 500px;
        //display: flex;
        //justify-content: space-between;
        //margin-bottom: 8px;
    }
    &-icon {
        height: 100%;
        font-size: 18px;
        margin-left: auto;
        padding-right: 12px;
        cursor: pointer;
    }
    &-closeIcon {
        text-align: right;
        font-size: 15px;
        color:#fff;
        i {
            cursor: pointer;
        }
    }
    &-month {
        margin-right: 12px;
    }
    &-year {
        margin-right: 12px;
        display: flex;
        width:100%;
    }
    &-button {
        width:100%;
        display: flex;
        justify-content: center;

        input[type="button"] {
            width: 80px;
            border-radius: 4px;
            padding: 8px;
            background-color: #0fd7b7;
            border: none;
            color: #374b62;
            cursor: pointer;
            font-family: Arimo;
            font-size: 12px;
            font-weight: bold;
        }
    }
}
</style>

